<script lang="ts">
  import type { IDocumentNode, PartialNode } from "@shared/common/node/type";
  import { onMount } from "svelte";
  import {
    getStore,
    setDocumentNodeContext,
    setIsChildDocument,
    setSlideNodeIndexContext,
  } from "../../context";

  const { impressionEventStatusMap } = getStore();

  export let node: PartialNode<IDocumentNode>;
  export let index: number;

  setDocumentNodeContext(node);
  setIsChildDocument(true);
  setSlideNodeIndexContext(index);

  onMount(() => {
    if (node.id) {
      $impressionEventStatusMap?.set(node.id, false);
    }
  });
</script>

<swiper-slide style="overflow:hidden">
  <slot />
</swiper-slide>
